import React, { Fragment } from 'react';
import Technician from '../../models/Technician';

const FormPartial = (props) => {
  const {technician, setTechnician} = props;
  const techicianObj = new Technician(technician);

  const validateValue = (field) => {
    techicianObj.validate(field);
    if(field === 'category'){
      techicianObj.validate('employee_id')
    }
  }

  const changeValue = (field, value) => {
    techicianObj[field] = value;
    validateValue(field);
    setTechnician(techicianObj.toStateJson());
  }

  return <Fragment>
    <div className="mt-4">
      <div className="row">
        <div className="col-md-6 my-2">
          <label htmlFor="name" className="form-label">Name</label>
          <input
            id="name"
            value={techicianObj.name}
            onChange={(e) => changeValue('name', e.target.value)}
            type="text"
            className="form-control form-control-sm font-size-12"
            placeholder='Enter Name'
            aria-describedby='name_help'
          />
          <div id="name_help" className="form-text text-danger mt-0">
            {techicianObj.errors.name}
          </div>
        </div>
        <div className="col-md-6 my-2">
          <label htmlFor="category" className="form-label">Technician Category</label>
          <select
            value={techicianObj.category}
            id="category"
            onChange={(e) => changeValue('category', e.target.value)}
            className="form-control form-control-sm font-size-12"
          >
            <option disabled value="">Choose Category</option>
            <option value="3P">3P</option>
            <option value="External">External</option>
          </select>
          <div id="category_help" className="form-text text-danger mt-0">
            {techicianObj.errors.category}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 my-2">
          <label htmlFor="mobile_number" className="form-label">Mobile Number</label>
          <input
            id="mobile_number"
            value={techicianObj.mobile_number}
            onChange={(e) => changeValue('mobile_number', e.target.value)}
            type="tel"
            maxLength={10}
            className="form-control form-control-sm font-size-12"
            placeholder='Enter Mobile Number'
            aria-describedby='mobile_number_help'
          />
          <div id="mobile_number_help" className="form-text text-danger mt-0">
            {techicianObj.errors.mobile_number}
          </div>
        </div>
        <div className="col-md-6 my-2">
          <label htmlFor="refppid" className="form-label">Ref PP Id</label>
          <input
            id="refppid"
            value={techicianObj.refppid}
            onChange={(e) => changeValue('refppid', e.target.value)}
            type="number"
            className="form-control form-control-sm font-size-12"
            placeholder='Enter Ref PP Id'
            aria-describedby='refppid_help'
          />
          <div id="refppid_help" className="form-text text-danger mt-0">
            {techicianObj.errors.refppid}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 my-2">
          <label htmlFor="employee_id" className="form-label">Employee Id</label>
          <input
            id="employee_id"
            value={techicianObj.employee_id}
            onChange={(e) => changeValue('employee_id', e.target.value)}
            type="text"
            className="form-control form-control-sm font-size-12"
            placeholder='Enter Employee Id'
            aria-describedby='employee_id_help'
          />
          <div id="employee_id_help" className="form-text text-danger mt-0">
            {techicianObj.errors.employee_id}
          </div>
        </div>
      </div>

    </div>
  </Fragment>
}

export default FormPartial;
